import React, { useState, useEffect } from 'react';
import { PublicNav } from './Landing';

const customStyles = `
  @keyframes blob {
    0% { transform: translate(0px, 0px) scale(1); }
    33% { transform: translate(30px, -50px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.9); }
    100% { transform: translate(0px, 0px) scale(1); }
  }
  .animate-blob { animation: blob 15s infinite alternate ease-in-out; }
`;

const Blogs = () => {
  const [isDark, setIsDark] = useState(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) return storedTheme === 'dark';
    if (document.documentElement.classList.contains('dark')) return true;
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    if (isDark) { document.documentElement.classList.add('dark'); localStorage.setItem('theme', 'dark'); } 
    else { document.documentElement.classList.remove('dark'); localStorage.setItem('theme', 'light'); }
  }, [isDark]);

  const articles = [
    { title: "The Future of AI in Tech Recruitment", category: "Industry Trends", date: "April 12, 2026" },
    { title: "How to Build Unbiased Interview Architectures", category: "Best Practices", date: "April 5, 2026" },
    { title: "Live Coding Assessments: Evaluating Logic Over Syntax", category: "Engineering", date: "March 28, 2026" },
  ];

  return (
    <div className="min-h-[100dvh] bg-slate-50 dark:bg-[#05050A] text-slate-900 dark:text-slate-200 font-sans relative overflow-hidden transition-colors duration-500 pt-24">
      <style>{customStyles}</style>
      <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vh] rounded-full bg-violet-600/10 blur-[120px] animate-blob z-0 pointer-events-none"></div>

      <PublicNav isDark={isDark} setIsDark={setIsDark} />

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="mb-12">
          <h1 className="text-4xl font-semibold tracking-wide text-slate-900 dark:text-white mb-3">Latest Insights</h1>
          <p className="text-sm font-light text-slate-500 dark:text-slate-400">Thoughts, news, and best practices from the RecruitGuru team.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article, idx) => (
            <div key={idx} className="bg-white/60 dark:bg-[#0a0a0a]/60 backdrop-blur-md p-8 rounded-[2rem] border border-slate-200 dark:border-white/10 shadow-sm hover:border-indigo-500/50 transition-colors cursor-pointer group flex flex-col h-64">
              <div className="flex justify-between items-center mb-auto">
                <span className="text-[12px] tracking-wide font-bold text-indigo-600 dark:text-indigo-400">{article.category}</span>
              </div>
              <div>
                <h3 className="text-xl font-medium text-slate-900 dark:text-white mb-4 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors leading-relaxed">{article.title}</h3>
                <span className="text-[12px] tracking-wide font-bold text-slate-400">{article.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blogs;